<template>
  <div style="min-width: 1033px" class="table">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>推送话单比对</el-breadcrumb-item>
      <el-breadcrumb-item>自动比对记录</el-breadcrumb-item>
      <!-- <el-breadcrumb-item>自动比对记录</el-breadcrumb-item> -->
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search mb-6" style="margin-top: 10px">
      <div class="searchItem">
        <p class="searchLabel">卡种类</p>
        <div class="searchInfo">
          <el-radio-group v-model="call_type_id" @change="esarchang(1)">
            <el-radio-button :label="0">全部</el-radio-button>
            <el-radio-button
              v-for="item in CallTypeCardArr"
              :key="item.id"
              :label="item.id"
            >
              {{ item.card }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="searchItem">
        <p class="searchLabel">风险提示</p>
        <div class="searchInfo">
          <el-radio-group v-model="is_complete" @change="esarchang(1)">
            <el-radio-button :label="99">全部</el-radio-button>
            <el-radio-button :label="0">异常</el-radio-button>
            <el-radio-button :label="1">正常</el-radio-button>
            <el-radio-button :label="2">低风险</el-radio-button>
            <el-radio-button :label="3">高风险</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div
      ref="caozuo"
      style="
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        line-height: 40px;
        margin-bottom: 10px;
      "
    >
      <div>
        <el-button size="small" plain @click="comeback">
          <i class="el-icon-back"></i> 返回</el-button
        >
        <el-button size="small" @click="shuaxin">
          <i class="el-icon-refresh-right"></i>
          刷新
        </el-button>
        <ExportExcel
          :E_ids="E_ids"
          :E_condition="E_condition"
          :E_dataLength="E_dataLength"
          :E_methodname="E_methodname"
          :E_searchArr="E_searchArr"
        ></ExportExcel>
      </div>

      <div>
        <ProjectSearch ref="searchform" :fields="steps" />
      </div>
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      @selection-change="handleSelectionChange"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <el-table-column
        type="selection"
        width="50"
        fixed="left"
      ></el-table-column>
      <el-table-column prop="mobile" label="主叫号码"></el-table-column>
      <el-table-column prop="CallTypeInfo" label="卡种类">
        <template slot-scope="scope">
          {{ scope.row.CallTypeInfo.card || "" }}
        </template>
      </el-table-column>
      <el-table-column prop="compareResultInfo" label="运营商">
        <template slot-scope="scope">
          {{ scope.row.operator_name || "" }}
        </template>
      </el-table-column>
      <el-table-column prop="AgentInfo" label="归属代理商">
        <template slot-scope="scope">
          {{ scope.row.AgentInfo.name || "" }}
        </template>
      </el-table-column>
      <el-table-column prop="CompanyInfo" label="企业">
        <template slot-scope="scope">
          {{ scope.row.CompanyInfo.name || "" }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="统计时间" width="180">
        <template slot-scope>
          <span>{{ compareTime.sday }}</span>
          <br />
          <span>{{ compareTime.eday }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="sday" label="主叫通话次数">
        <el-table-column prop="province" label="系统" width="100">
          <template slot-scope="scope">
            {{ scope.row.inner.pass }}
          </template>
        </el-table-column>
        <el-table-column prop="city" label="运营商" width="100">
          <template slot-scope="scope">
            {{ scope.row.outer.pass }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="误差" width="100">
          <template slot-scope="scope">
            {{ scope.row.inner.wucha_pass }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="百分比" width="100">
          <template slot-scope="scope">
            {{ scope.row.inner.wucha_pass_avg }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="通话分钟数">
        <el-table-column prop="province" label="系统" width="100">
          <template slot-scope="scope">
            {{ scope.row.inner.minute }}
          </template>
        </el-table-column>
        <el-table-column prop="city" label="运营商" width="100">
          <template slot-scope="scope">
            {{ scope.row.outer.minute }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="误差" width="100">
          <template slot-scope="scope">
            {{ scope.row.inner.wucha_minute }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="百分比" width="100">
          <template slot-scope="scope">
            {{ scope.row.inner.wucha_minute_avg }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="type" label="风险提示">
        <template slot-scope="scope">
          <span
            v-if="scope.row.is_complete == 0"
            style="color: #0070cb"
          >
            异常
          </span>
          <span
            v-else-if="scope.row.is_complete == 1"
            style="color: green"
          >
            正常
          </span>
          <span
            v-else-if="scope.row.is_complete == 2"
            style="color: #fdd899"
          >
            低风险
          </span>
          <span v-else style="color: red">高风险</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 500, 1000, 5000]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
  </div>
</template>

<script>
import { getData } from "@/api/index";
import { debounce } from "@/utils/tool.js";
import ExportExcel from "@/components/ExportExcel";
import { automaticComparisonDetailSearch } from "@/config/telemarketingSearch";
import ProjectSearch from "@/components/ProjectSearch.vue";
export default {
  components: {
    ExportExcel,
    ProjectSearch,
  },
  data() {
    return {
      zhanshi: "800px",
      caozuoheight: 0,
      E_ids: [], //选中id
      E_condition: {}, //条件
      E_dataLength: 0, //数据长度
      E_methodname: "agent_comparison_record", //方法名
      E_searchArr: [
        "mobile",
        "is_complete",
        "call_type_id",
        "plat_id",
        "parent_id",
        "company_id",
      ], //搜索条件过滤
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      formes: {},
      field: "1",
      search_field: "",
      compareTime: {
        sday: "",
        eday: "",
      },
      steps: [],
      CallTypeCardArr: [],
      call_type_id: 0,
      is_complete: 99,
    };
  },
  async created() {
    this.compare_id = this.$route.params.compare_id;
    await Promise.all([
      this.$fetchDicByField("AgentData1"),
      this.$fetchDicByField("OperatorArr"),
      this.$fetchDicByField("CompanyData"),
      this.getCallSeat(),
      this.getlistData({
        page: this.currentPage,
        pagesize: this.pagesize,
        compare_id: this.compare_id,
      }),
    ]);
    this.steps = automaticComparisonDetailSearch;
  },
  mounted() {
    setTimeout(() => {
      var H = document.body.clientHeight;
      this.zhanshi = H - this.caozuoheight - 344;
    }, 100);
    const that = this;
    window.onresize = () => {
      var H = document.body.clientHeight;
      that.zhanshi = H - this.caozuoheight - 344;
    };
  },
  methods: {
    getCallSeat() {
      getData("call.CallTypeController/tableListAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.CallTypeCardArr = res.data.filter((item) => item.is_card == 1);
      });
    },
    inputsearch: debounce(function(e) {
      this.esarchang(1);
    }),
    handleSelectionChange(val) {
      this.E_ids = [];
      val.forEach((i) => {
        this.E_ids.push(i.id);
      });
    },
    //搜索
    esarchang(flag) {
      if (flag) {
        this.currentPage = 1;
        this.pagesize = 20;
      }
      let params = {
        page: this.currentPage,
        pagesize: this.pagesize,
        type: this.callordertype,
        compare_id: this.compare_id,
      };
      if (this.call_type_id !== 0) params.call_type_id = this.call_type_id;
      if (this.is_complete !== 99) params.is_complete = this.is_complete;
      if (
        this.$refs.searchform.selectContent !== null &&
        this.$refs.searchform.selectContent
      ) {
        params[
          this.$refs.searchform.selectOption
        ] = this.$refs.searchform.selectContent;
      }
      this.getlistData(params);
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    comeback() {
      this.$router.push({
        name: "pushBillComparison",
        params: {
          routeName: this.$route.params.routeName,
          pathName: this.$route.params.pathName,
          pathRouter: this.$route.params.pathRouter,
          call_type_id: this.$route.params.call_type_id,
        },
      });
    },
    //刷新
    shuaxin() {
      this.call_type_id = 0;
      this.is_complete = 99;
      this.$refs.searchform.selectOption = this.steps[0].name;
      this.$refs.searchform.selectContent = null;
      this.esarchang(1);
      this.$message({ message: "刷新成功", type: "success" });
    },
    //请求数据
    getlistData(data) {
      this.tableData = [];
      this.E_condition = { ...data, xh_excel: 1 };
      getData("compare.CompareResultController/pageAction", data).then(
        (res) => {
          if (res.code !== 200) return this.$message.error(res.message);
          this.tableData = res.data.list.data;
          this.compareTime.sday = res.data.compare.sday;
          this.compareTime.eday = res.data.compare.eday;
          this.total = res.data.list.total;
          this.E_dataLength = res.data.list.total;
          this.pagesize = res.data.list.per_page;
        }
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.esarchang();
    },
    // 分页
    current_change: function(currentPage) {
      this.currentPage = currentPage;
      this.esarchang();
    },
  },
  filters: {
    compareResultType(type) {
      switch (Number(type)) {
        case 1:
          return "鑫源";
        case 2:
          return "lenovo";
        case 3:
          return "蓝猫";
        case 4:
          return "三五字节云";
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
.pagination_bottom /deep/ .el-input__inner {
  height: 28px;
  line-height: 28px;
}
</style>
<style lang="less" src="@/assets/css/records.less" scoped></style>
<style src="@/assets/css/index.css" scoped></style>
